/* Presentation only: Ghost's members script owns email delivery and authentication. */
(function () {
    const dialog = document.querySelector('.studio-members-dialog');
    if (!dialog || !window.HTMLDialogElement) return;
    const title = dialog.querySelector('h2');
    let opener;

    function show(mode) {
        dialog.querySelectorAll('[data-members-form]').forEach(form => {
            form.hidden = form.dataset.membersForm !== mode;
        });
        dialog.querySelectorAll('[data-members-switch]').forEach(text => {
            text.hidden = text.dataset.membersSwitch !== mode;
        });
        title.textContent = title.dataset[mode + 'Title'];
        if (!dialog.open) {
            opener = document.activeElement;
            dialog.showModal();
        }
        dialog.querySelector('form:not([hidden]) input').focus();
    }

    function route(value) {
        return /^(signup|signin)$/.test(value) ? value : null;
    }

    // Capture before Portal's delegated handlers; leave account, plans and billing alone.
    window.addEventListener('click', event => {
        if (event.defaultPrevented || event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const link = event.target.closest('a, button');
        if (!link || link.target === '_blank') return;
        let mode = route(link.getAttribute('data-portal'));
        if (link.hasAttribute('data-portal') && link.getAttribute('data-portal') === '') mode = 'signup';
        if (!mode && link.tagName === 'A') {
            const url = new URL(link.href, location.href);
            if (url.origin === location.origin && url.pathname === location.pathname) {
                mode = route(url.hash.replace(/^#\/portal\//, ''));
            }
        }
        if (!mode) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        show(mode);
    }, true);

    dialog.querySelectorAll('[data-members-mode]').forEach(button => {
        button.addEventListener('click', () => show(button.dataset.membersMode));
    });
    dialog.querySelector('.studio-members-close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
        const box = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
    });
    dialog.addEventListener('close', () => {
        if (opener && opener.isConnected) opener.focus({preventScroll: true});
    });

    function openHash() {
        const mode = route(location.hash.replace(/^#\/portal\//, ''));
        if (!mode) return;
        history.replaceState(history.state, '', location.pathname + location.search);
        show(mode);
    }
    window.addEventListener('hashchange', openHash);
    openHash();
}());
